import withLog from './WithLog.react';
import {PropTypes} from 'prop-types';
import LoggingPropTypes from '../../../Contexts/Logging/PropTypes';
import withLifecycleEvents from './WithLifecycleEvents.react';
import React from 'react';

/**
 * Extends a Component Class with logging calls for Render, ComponentDidMount, and ComponentDidUpdate.
 * @param ComponentClass
 * @returns A new Component Class.
 */
function withLifecycleLogging(ComponentClass) {
    let displayName = ComponentClass.displayName || ComponentClass.name || 'Component';
    let ComponentClassWithLifecycleEvents = withLifecycleEvents(ComponentClass);
    // eslint-disable-next-line react/display-name,react/no-multi-comp
    let componentClass = class extends React.PureComponent {
        constructor(props) {
            super(props);
            this.state = {};
            this.onComponentDidMount = [
                (sender) => {
                    this.state.log.trace(`${displayName}.componentDidMount`, {
                        props: sender.props,
                        state: sender.state,
                    });
                },
            ];
            this.onComponentDidUpdate = [
                (sender) => {
                    this.state.log.trace(`${displayName}.componentDidUpdate`, {
                        props: sender.props,
                        state: sender.state,
                    });
                },
            ];
            this.onRender = [
                (sender) => {
                    this.state.log.trace(`${displayName}.render`, {
                        props: sender.props,
                        state: sender.state,
                    });
                },
            ];
        }

        static getDerivedStateFromProps(nextProps, prevState) {
            return {
                log: nextProps.log,
            };
        }

        render() {
            let {log, ...props} = this.props;
            return (
                <ComponentClassWithLifecycleEvents
                    {...props}
                    onComponentDidUpdate={this.onComponentDidUpdate}
                    onComponentDidMount={this.onComponentDidMount}
                    onRender={this.onRender}
                />
            );
        }
    };

    componentClass.propTypes = {
        ...ComponentClass.propTypes,
        log: PropTypes.shape(LoggingPropTypes).isRequired,
    };

    return withLog(componentClass);
}

export default withLifecycleLogging;
